import React, { FC } from 'react';
import { Text, Avatar, AvatarSize, Button } from 'wix-ui-tpa/cssVars';

import { classes } from './ActionableMemberRow.st.css';
import { MemberListItem } from '../../../../../types';

interface MemberData {
  member: MemberListItem;
  buttonText: string;
  onAction?: () => void;
}

export const ActionableMemberRow: FC<MemberData> = ({
  member,
  onAction,
  buttonText,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.leftSide}>
        <Avatar
          size={AvatarSize.medium}
          name={member.name}
          src={member.photo}
          className={classes.avatar}
        />
        <div className={classes.description}>
          <Text tagName="div">{member.name}</Text>
        </div>
      </div>

      <Button upgrade onClick={onAction} className={classes.button}>
        {buttonText}
      </Button>
    </div>
  );
};
